import styled from 'styled-components'

export const Subtitle = styled.div`
  margin-bottom: 16px;
`
